export default __webpack_public_path__ + "static/media/map-pin-dark.7c031cb3.svg";